import { render, staticRenderFns } from "./PerformanceActivitiesList.vue?vue&type=template&id=679317d0&scoped=true&"
import script from "./PerformanceActivitiesList.vue?vue&type=script&lang=ts&"
export * from "./PerformanceActivitiesList.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceActivitiesList.vue?vue&type=style&index=0&id=679317d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679317d0",
  null
  
)

export default component.exports